import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useProfile } from '@lib/profile';
import { useIsMobile } from '@hooks';
import { RESOLUTION_BREAKPOINT } from '@constants';
const redirectToIdentificationBlocked = (identification, pathname, navigate) => {
    if (identification.isPendingOfValidation()) {
        if (pathname !== '/update-identification/success')
            navigate('/update-identification/success');
        return true;
    }
    const inUpdateFlow = pathname.startsWith('/update-identification');
    if (identification.isExpired()) {
        if (!inUpdateFlow)
            navigate('/update-identification/expired');
        return true;
    }
    if (identification.isRejected()) {
        if (!inUpdateFlow)
            navigate('/update-identification/rejected');
        return true;
    }
    return false;
};
const navigateToProfileState = (profile, investorBalance, isSmallResolution, navigate) => {
    if (profile?.pendingCorrectionRequests.hasW8ContractRequest()) {
        navigate('/perfil/w8-contract');
    }
    else if (!profile?.hasTransactionalProfile()) {
        navigate('/update-transactional-profile');
    }
    else if (investorBalance?.hasInvested()) {
        navigate(isSmallResolution ? '/home' : '/marketplace');
    }
    else {
        navigate('/onboarding');
    }
};
const LimitlessLevelOutlet = () => {
    const navigate = useNavigate();
    const isSmallResolution = useIsMobile(RESOLUTION_BREAKPOINT.small);
    const { profile, investorBalance } = useProfile();
    const { pathname, state } = useLocation();
    useEffect(() => {
        if (profile && redirectToIdentificationBlocked(profile.identification, pathname, navigate)) {
            return;
        }
        if (profile?.pendingCorrectionRequests.hasAddressProofRenewalRequest()
            && !profile.identification.hasInconsistentData()) {
            navigate('/perfil/documentos-rechazados');
            return;
        }
        if (state?.from?.pathname) {
            navigate(state.from.pathname);
            return;
        }
        if (pathname !== '/' && pathname !== '/update-identification/success') {
            return;
        }
        navigateToProfileState(profile, investorBalance, isSmallResolution, navigate);
    }, [pathname, profile]);
    return (_jsx(Outlet, {}));
};
export default LimitlessLevelOutlet;
